// styles/variables.js
export const variables = {
    primaryColor: '#E4350A',
    fontFamily: "'Poppins', sans-serif",
  };
  